export default "__VITE_ASSET__9sfW7wrg__"